import { t } from "@be-miniapp/i18n"

export type SelectRouteAddressType =
  | "pick-up"
  | "drop-off"
  | "user-location"
  | "food-location"
  | "save-address"

/**
 * Creates action bar suffix configuration
 */
export function createActionBarSuffix(
  isMapVisible: boolean,
  handleToggleMap: () => void
): { text: string; onClick: () => void } | null {
  if (isMapVisible) return null

  return {
    text: t("ride.common.pick_from_map"),
    onClick: handleToggleMap,
  }
}

/**
 * Creates action bar title based on address type
 */
export function createActionBarTitle(
  currentAddressType: SelectRouteAddressType
): string {
  return currentAddressType === "pick-up"
    ? t("ride.common.pick_up")
    : t("ride.common.drop_off")
}
